import axiosInstance from "../utils/axios";

export const resetPassword = async (newAccountData) => {
  const { userId, password } = newAccountData;
  const res = await axiosInstance.put(`/account/reset/password/${userId}`, {
    password: password,
  });
  return res.data;
};
